import { FormHelperText, TextField, type TextFieldProps } from "@mui/material";

interface TextAreaProps
  extends Omit<TextFieldProps, "variant" | "onChange" | "multiline"> {
  field: any;
  error?: boolean;
  helperText?: string;
  maxLength?: number;
  numbersOnly?: boolean;
  isHint?: boolean;
  maxChar?: number;
}

const TextArea: React.FC<TextAreaProps> = ({
  field,
  error,
  helperText,
  maxLength,
  numbersOnly,
  slotProps,
  rows = 3,
  isHint = false,
  maxChar = 0,
  ...rest
}) => {
  const hasValue = !!field?.value;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = !isHint ? e.target.value : e.target.value.slice(0, maxChar);

    if (numbersOnly) {
      value = value.replace(/[^0-9]/g, "");
    }

    if (maxLength) {
      value = value.slice(0, maxLength);
    }

    field.onChange(value);
  };

  return (
    <div>
      <TextField
        {...rest}
        {...field}
        variant="standard"
        multiline
        rows={rows}
        fullWidth
        value={field?.value ?? ""}
        onChange={handleChange}
        error={error}
        helperText={helperText}
        slotProps={{
          ...slotProps,
          inputLabel: {
            shrink: hasValue || undefined,
            ...slotProps?.inputLabel,
          },
          htmlInput: {
            maxLength,
            ...slotProps?.htmlInput,
          },
        }}
      />

      {isHint && (
        <FormHelperText style={{ textAlign: "left" }}>
          {(field.value?.length || 0)} / {maxChar}
        </FormHelperText>
      )}
    </div>
  );
};

export default TextArea;